import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from '../shared/auth';
import { LoginPage } from '../features/auth/LoginPage';
import { AppLayout } from './AppLayout';
import { DashboardPage } from '../features/dashboard/DashboardPage';
import { ClientsPage } from '../features/clients/ClientsPage';
import { ClientDetailPage } from '../features/clients/ClientDetailPage';
import { ProvidersPage } from '../features/providers/ProvidersPage';
import { ProviderDetailPage } from '../features/providers/ProviderDetailPage';
import { ServicesPage } from '../features/services/ServicesPage';
import { GroupsPage } from '../features/groups/GroupsPage';
import { RoomsPage } from '../features/rooms/RoomsPage';
import { IntakeWizardPage } from '../features/intake/IntakeWizardPage';
import { SchedulePage } from '../features/schedule/SchedulePage';
import { AttendanceTodayPage } from '../features/attendance/AttendanceTodayPage';
import { DailyAttendanceSheetPage } from '../features/attendance/DailyAttendanceSheetPage';
import { SettingsPage } from '../features/settings/SettingsPage';
import { ReportsPage } from '../features/reports/ReportsPage';
import { PrintClientWeekPage } from '../features/schedule/PrintClientWeekPage';
import { PrintProviderWeekPage } from '../features/schedule/PrintProviderWeekPage';
import { NotificationsPage } from '../features/notifications/NotificationsPage';
import { PipelinePage } from '../features/pipeline/PipelinePage';
import { ScheduledReportsPage } from '../features/scheduled-reports/ScheduledReportsPage';
import { MasterDataPage } from '../features/master-data/MasterDataPage';
import { HousingPage } from '../features/housing/HousingPage';
import { UsersPage } from '../features/users/UsersPage';
import { AllPatientsPage } from '../features/patients/AllPatientsPage';
import { LocationsPage } from '../features/locations/LocationsPage';

export default function App() {
  const { user, loading, hydrate } = useAuth();
  const isAdmin = user?.role === 'ADMIN';

  useEffect(() => {
    void hydrate();
  }, [hydrate]);

  if (loading) {
    return (
      <div className="grid h-full place-items-center">
        <div className="text-sm text-slate-500">Loading...</div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/print/client/:id" element={user ? <PrintClientWeekPage /> : <Navigate to="/login" replace />} />
      <Route path="/print/provider/:id" element={user ? <PrintProviderWeekPage /> : <Navigate to="/login" replace />} />
      <Route path="/print/daily-sheet" element={user ? <DailyAttendanceSheetPage print /> : <Navigate to="/login" replace />} />
      {user ? (
        <Route element={<AppLayout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/clients" element={<ClientsPage />} />
          <Route path="/clients/:id" element={<ClientDetailPage />} />
          <Route path="/patients" element={<AllPatientsPage />} />
          <Route path="/providers" element={<ProvidersPage />} />
          <Route path="/providers/:id" element={<ProviderDetailPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/groups" element={<GroupsPage />} />
          <Route path="/rooms" element={<RoomsPage />} />
          <Route path="/intake" element={<IntakeWizardPage />} />
          <Route path="/pipeline" element={<PipelinePage />} />
          <Route path="/schedule" element={<SchedulePage />} />
          <Route path="/attendance" element={<AttendanceTodayPage />} />
          <Route path="/attendance/sheet" element={<DailyAttendanceSheetPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/scheduled-reports" element={<ScheduledReportsPage />} />
          <Route path="/master-data" element={<MasterDataPage />} />
          <Route path="/housing" element={<HousingPage />} />
          <Route path="/locations" element={<LocationsPage />} />
          {isAdmin && <Route path="/users" element={<UsersPage />} />}
          {isAdmin && <Route path="/settings" element={<SettingsPage />} />}
          {!isAdmin && <Route path="/users" element={<Navigate to="/" replace />} />}
          {!isAdmin && <Route path="/settings" element={<Navigate to="/" replace />} />}
        </Route>
      ) : (
        <Route path="*" element={<Navigate to="/login" replace />} />
      )}
    </Routes>
  );
}
